// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Users, ListOrdered, TrendingUp, History, Plus, Eye, Pencil, Trash2 } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { getEmployeeList } from '../../../action/Employee';
// import { getDesignationList } from '../../../action/Designation';
// import { savePayrollEntity } from '../../../action/Payroll';
// import AssignEmployeeSalaryDialog from '../../../components/EmployeeSalary/AssignEmployeeSalaryDialog';
// import AddEmployeeSalaryComponentDialog from '../../../components/EmployeeSalary/AddEmployeeSalaryComponentDialog';
// import EmployeeSalaryDialog from '../../../components/EmployeeSalary/EmployeeSalaryDialog';
// import { toast } from 'react-toastify';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';
// import { useConfirm } from '../../../utils/ConfirmContext';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// /* Every table on this page shares these. */
// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

// /* ── Employee Salary ─────────────────────────────────────────────────────── */
// /*
// const EmployeeSalaryTab = () => {
//   const dispatch = useDispatch();

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState('add');
//   const [selectedSalary,setSelectedSalary] = useState(null);

//   const employees = useSelector((state) => state.employee.list);
//   const designations = useSelector((state) => state.designation.list);

//   const { list, loading } = usePayrollEntity('employeeSalary');
//   const { list: periods } = usePayrollEntity('payrollPeriods');

//   useEffect(() => {
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getDesignationList()).catch(() => {});
//   }, [dispatch]);

//   const employeeMap = employees.reduce((map, emp) => {
//     map[emp.HED_SERVICE_NO] = emp;
//     return map;
//   }, {});

//   const designationMap = designations.reduce((map, designation) => {
//     map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
//     return map;
//   }, {});

//   const handleAdd = () => {
//     setSelectedSalary(null);
//     setDialogMode('add');
//     setOpen(true);
//   }

//   const handleView = (record) => {
//     setSelectedSalary(record);
//     setDialogMode('view');
//     setOpen(true);
//   }

//   const handleEdit = (record) => {
//     setSelectedSalary(record);
//     setDialogMode('edit');
//     setOpen(true);
//   }

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('employeeSalary', form, dialogMode === 'edit'));
//     setOpen(false);
//     setSelectedSalary(null);
//     setDialogMode('add');
//   };

//   const handleClose = () => {
//     setOpen(false);
//   }

//   const handleDialogExited = () => {
//     setSelectedSalary(null);
//     setDialogMode('add');
//   }

//   const handleDelete = async (record) => {
//     const confirmed = window.confirm(
//       `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`
//     );

//     if (!confirmed) {
//       return;
//     }

//     try {
//       await dispatch(
//         savePayrollEntity(
//           'employeeSalary',
//           {
//             id: record.id,
//             isActive: false,
//           },
//           true
//         )
//       );

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode('add');
//     } catch (err) {
//       console.error('Failed to delte employee salary: ', err);
//     }
//   }

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Employee Salary"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={['empNo', 'name', 'department']}
//         searchPlaceholder="Search by employee name or number..."
//         emptyMessage="No salary records found"
//         onAdd={{ label: 'Assign Salary', icon: <Plus {...ICON} />, onClick: handleAdd }}
//         columns={[
//           { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
//           {
//             key: 'designation',
//             label: 'Designation',
//             className: 'text-gray-600',
//             render: (r) => {
//               const emp = employeeMap[r.empNo];
//               return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
//             },
//           },
//           { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
//           // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
//           { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
//           // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
//           { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
//           { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-2">
//                 <button
//                   type="button"
//                   onClick={() => handleView(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="View"
//                 >
//                   <Eye size={16} /> 
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEdit(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="Update"
//                 >
//                   <Pencil size={16} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDelete(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-red-50
//                     hover:text-red-600
//                     transition-colors
//                   "
//                   title="Delete"
//                 >
//                   <Trash2 size={16} />
//                 </button>
//               </div>
//             ),
//           },
//         ]}
//       />

//       <AssignEmployeeSalaryDialog
//         open={open}
//         onClose={handleClose}
//         onExited={handleDialogExited}
//         onSave={handleSave}
//         employees={employees}
//         payrollPeriods={periods}
//         employeeSalaries={list}
//         mode={dialogMode}
//         salary={selectedSalary}
//       />
//     </>
//   );
// };
// */

// /* ── Salary Components ───────────────────────────────────────────────────── */
// /*
// const SalaryComponentsTab = () => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   const { list, loading } = usePayrollEntity('employeeSalaryComponents');
//   const { list: components } = usePayrollEntity('payrollComponents');
//   const { list: employeeSalaries } = usePayrollEntity('employeeSalary');

//   const [open, setOpen] = useState(false);
//   const [employeeSalaryId, setEmployeeSalaryId] = useState('');

//   const filtered = list
//     .filter((x) => String(x.employeeSalaryId) === String(employeeSalaryId))
//     .map((x) => ({
//       ...x,
//       componentName: components.find((c) => c.id === x.componentId)?.name ?? x.remarks,
//     }));

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('employeeSalaryComponents', form));
//     setOpen(false);
//   };

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         search={false}
//         title="Salary Components"
//         loading={loading}
//         rows={filtered}
//         rowKey="id"
//         emptyMessage="Please select an employee to view records."
//         onAdd={{
//           label: 'Assign Component',
//           icon: <Plus {...ICON} />,
//           onClick: () => {
//             if (!employeeSalaryId) return;
//             setOpen(true);
//           },
//         }}
//         toolbarExtra={
//           <div className="w-[320px] max-w-full">
//             <span className={LABEL}>Employee</span>
//             <select
//               value={employeeSalaryId}
//               onChange={(e) => setEmployeeSalaryId(e.target.value)}
//               className={`${FIELD} w-full`}
//             >
//               <option value="">Select Employee</option>
//               {employeeSalaries.map((salary) => (
//                 <option key={salary.id} value={salary.id}>
//                   {salary.empNo} - {salary.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         }
//         columns={[
//           { key: 'componentName', label: 'Component', grow: true, className: 'font-semibold text-gray-900' },
//           { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.amount) },
//           { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'endDate', label: 'End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           {
//             key: 'status',
//             label: 'Status',
//             align: 'center',
//             render: (r) => <StatusPill label={r.isActive ? 'Active' : 'Inactive'} />,
//           },
//         ]}
//       />

//       <AddEmployeeSalaryComponentDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         employeeSalaryId={employeeSalaryId}
//         payrollComponents={components}
//       />
//     </>
//   );
// };
// /*

// /* ── Salary Revision ─────────────────────────────────────────────────────── */
// /*
// const SalaryRevisionTab = () => {
//   const { list, loading } = usePayrollEntity('salaryRevision');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Salary Revision"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['empNo', 'name']}
//       searchPlaceholder="Search salary revisions..."
//       emptyMessage="No salary revisions found"
//       onAdd={{ label: 'New Revision', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
//         { key: 'oldBasic', label: 'Old Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
//         { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
//         { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
//         { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//         { key: 'reason', label: 'Reason', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };
// /*

// /* ── Increment History ───────────────────────────────────────────────────── */
// /*
// const IncrementHistoryTab = () => {
//   const { list, loading } = usePayrollEntity('incrementHistory');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Increment History"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['empNo', 'name', 'cycle']}
//       searchPlaceholder="Search increment history..."
//       emptyMessage="No increment history found"
//       columns={[
//         { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
//         { key: 'cycle', label: 'Review Cycle', className: 'text-gray-600' },
//         { key: 'oldBasic', label: 'Previous Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
//         { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
//         { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
//         { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//       ]}
//     />
//   );
// };
// /*

// /* ── Page ────────────────────────────────────────────────────────────────── */
// /*
// const PayrollEmployeeSalary = () => {
//   const tabs = [
//     { key: 'salary', label: 'Employee Salary', icon: <Users {...ICON} />, content: <EmployeeSalaryTab /> },
//     { key: 'components', label: 'Salary Components', icon: <ListOrdered {...ICON} />, content: <SalaryComponentsTab /> },
//     // { key: 'revision', label: 'Salary Revision', icon: <TrendingUp {...ICON} />, content: <SalaryRevisionTab /> },
//     // { key: 'history', label: 'Increment History', icon: <History {...ICON} />, content: <IncrementHistoryTab /> },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Employee Salary']}
//         title="Employee Salary"
//         subtitle="Assign, revise and track individual employee salary records."
//       />
//       <Tabs tabs={tabs} defaultTab="salary" />
//     </div>
//   );
// };

// export default PayrollEmployeeSalary;
// */

// const PayrollEmployeeSalary = () => {
//   const dispatch = useDispatch();
//   const confirm = useConfirm();

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState("add");
//   const [selectedSalary, setSelectedSalary] = useState(null);

//   const employees = useSelector((state) => state.employee.list);
//   const designations = useSelector((state) => state.designation.list);

//   const employeeMap = employees.reduce((map, emp) => {
//     map[emp.HED_SERVICE_NO] = emp;
//     return map;
//   }, {});

//   const designationMap = designations.reduce((map, designation) => {
//     map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
//     return map;
//   }, {});

//   const { list, loading } = usePayrollEntity("employeeSalary");
//   const { list: components } = usePayrollEntity("employeeSalaryComponents");
//   const { list: payrollComponents } = usePayrollEntity("payrollComponents");

//   const { toast, showToast, hideToast } = useToast();

//   useEffect(() => {
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getDesignationList()).catch(() => {});
//   }, [dispatch]);

//   const handleAdd = () => {
//     setSelectedSalary(null);
//     setDialogMode("add");
//     setOpen(true);
//   };

//   const handleView = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("view");
//     setOpen(true);
//   };

//   const handleEdit = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("edit");
//     setOpen(true);
//   };

//   const handleSave = async (form, pendingComponents = []) => {
//     try {
//       const isEdit = dialogMode === "edit";

//       // Save employee salary and get the employeeSalaryId
//       const employeeSalaryId = await dispatch(
//         savePayrollEntity(
//           "employeeSalary",
//           form,
//           isEdit
//         )
//       );

//       // For the new salary, save each salary component
//       if (pendingComponents.length > 0) {
//         await Promise.all(
//           pendingComponents.map((component) => {
//             dispatch(
//               savePayrollEntity(
//                 "employeeSalaryComponents",
//                 {
//                   employeeSalaryId,
//                   componentId: component.componentId,
//                   amount: component.amount,
//                   percentage: component.percentage,
//                   effectiveDate: component.effectiveDate,
//                   endDate: component.endDate,
//                   isActive: component.isActive,
//                   remarks: component.remarks,
//                 },
//                 false
//               )
//             )
//           })
//         )
//       }

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode("add");

//       showToast(isEdit ? "Employee salary updated successfully." : "Employee salary saved successfully.", "success");

//     } catch (error) {
//       console.error("Failed to save employee salary: ", error);

//       showToast(
//         error?.response?.data?.message ||
//         error?.response?.data?.Message ||
//         error?.message ||
//         "Failed to save employee salary.",
//         'error'
//       );
//     }
//   };

//   const handleUpdateComponent = async (component) => {
//     try {
//       await dispatch(
//         savePayrollEntity(
//           "employeeSalaryComponents",
//           component,
//           true
//         )
//       );

//       showToast("Salary component updated successfully.", "success");
//     } catch (error) {
//       console.error("Failed to update salary component: ", error);
//       showToast(
//         error?.response?.data?.Message ||
//         error?.response?.data?.message || 
//         error?.message || 
//         "Failed to update salary component.",
//         "error"
//       )

//       throw error;
//     }
//   }

//   const handleDelete = async (record) => {
//     const confirmed = await confirm({
//       title: "Delete this salary?",
//       message: `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`,
//       confirmLabel: "Delete",
//       cancelLabel: "Cancel",
//     })

//     if (!confirmed) {
//       return;
//     }

//     try {
//       await dispatch(
//         savePayrollEntity(
//           'employeeSalary',
//           {
//             id: record.id,
//             isActive: false,
//           },
//           true
//         )
//       );

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode('add');
//     } catch (err) {
//       console.error('Failed to delte employee salary: ', err);
//     }
//   }

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={["Payroll", "Employee Salary"]}
//         title="Employee Salary"
//         subtitle="Assign, revise and track individual employee salary records."
//       />

//       <Table
//         {...TABLE_PROPS}
//         title="Employee Salary"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={["empNo", "name", "department"]}
//         searchPlaceholder="Search by employee name or number..."
//         emptyMessage="No salary records found"
//         onAdd={{
//           label: "Assign Salary",
//           icon: <Plus {...ICON} />,
//           onClick: handleAdd,
//         }}
//         columns={[
//           { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
//           {
//             key: 'designation',
//             label: 'Designation',
//             className: 'text-gray-600',
//             render: (r) => {
//               const emp = employeeMap[r.empNo];
//               return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
//             },
//           },
//           { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
//           // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
//           { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
//           // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
//           { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
//           { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-2">
//                 <button
//                   type="button"
//                   onClick={() => handleView(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="View"
//                 >
//                   <Eye size={16} /> 
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEdit(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="Update"
//                 >
//                   <Pencil size={16} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDelete(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-red-50
//                     hover:text-red-600
//                     transition-colors
//                   "
//                   title="Delete"
//                 >
//                   <Trash2 size={16} />
//                 </button> 
//               </div>
//             ),
//           },
//         ]}
//       />

//       <EmployeeSalaryDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         onSaveComponent={handleUpdateComponent}
//         employees={employees}
//         employeeSalaries={list}
//         salary={selectedSalary}
//         mode={dialogMode}
//         salaryComponents={components}
//         payrollComponents={payrollComponents}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollEmployeeSalary;



//------------------------------------------------------------------------------------------------

// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Users, ListOrdered, TrendingUp, History, Plus, Eye, Pencil, Trash2 } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { fetchAllEmployees } from '../../../store/slices/employeeSlice';
// import { getDesignationList } from '../../../store/slices/designationSlice';
// import { savePayrollEntity } from '../../../store/slices/payrollSlice';
// import AssignEmployeeSalaryDialog from '../../../components/EmployeeSalary/AssignEmployeeSalaryDialog';
// import AddEmployeeSalaryComponentDialog from '../../../components/EmployeeSalary/AddEmployeeSalaryComponentDialog';
// import EmployeeSalaryDialog from '../../../components/EmployeeSalary/EmployeeSalaryDialog';
// import { toast } from 'react-toastify';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';
// import { useConfirm } from '../../../utils/ConfirmContext';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// /* Every table on this page shares these. */
// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

/* ── Employee Salary ─────────────────────────────────────────────────────── */
/*
const EmployeeSalaryTab = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('add');
  const [selectedSalary,setSelectedSalary] = useState(null);

  const employees = useSelector((state) => state.employees.employees);
  const designations = useSelector((state) => state.designationSlice.designations);

  const { list, loading } = usePayrollEntity('employeeSalary');
  const { list: periods } = usePayrollEntity('payrollPeriods');

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(getDesignationList());
  }, [dispatch]);

  const employeeMap = employees.reduce((map, emp) => {
    map[emp.HED_SERVICE_NO] = emp;
    return map;
  }, {});

  const designationMap = designations.reduce((map, designation) => {
    map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
    return map;
  }, {});

  const handleAdd = () => {
    setSelectedSalary(null);
    setDialogMode('add');
    setOpen(true);
  }

  const handleView = (record) => {
    setSelectedSalary(record);
    setDialogMode('view');
    setOpen(true);
  }

  const handleEdit = (record) => {
    setSelectedSalary(record);
    setDialogMode('edit');
    setOpen(true);
  }

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('employeeSalary', form, dialogMode === 'edit'));
    setOpen(false);
    setSelectedSalary(null);
    setDialogMode('add');
  };

  const handleClose = () => {
    setOpen(false);
  }

  const handleDialogExited = () => {
    setSelectedSalary(null);
    setDialogMode('add');
  }

  const handleDelete = async (record) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`
    );

    if (!confirmed) {
      return;
    }

    try {
      await dispatch(
        savePayrollEntity(
          'employeeSalary',
          {
            id: record.id,
            isActive: false,
          },
          true
        )
      );

      setOpen(false);
      setSelectedSalary(null);
      setDialogMode('add');
    } catch (err) {
      console.error('Failed to delte employee salary: ', err);
    }
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Employee Salary"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={['empNo', 'name', 'department']}
        searchPlaceholder="Search by employee name or number..."
        emptyMessage="No salary records found"
        onAdd={{ label: 'Assign Salary', icon: <Plus {...ICON} />, onClick: handleAdd }}
        columns={[
          { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
          {
            key: 'designation',
            label: 'Designation',
            className: 'text-gray-600',
            render: (r) => {
              const emp = employeeMap[r.empNo];
              return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
            },
          },
          { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
          // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
          { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
          // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
          { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
          { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-2">
                <button
                  type="button"
                  onClick={() => handleView(r)}
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-md
                    text-gray-500
                    hover:bg-surface-100
                    hover:text-primary-600
                    transition-colors
                  "
                  title="View"
                >
                  <Eye size={16} /> 
                </button>

                <button
                  type="button"
                  onClick={() => handleEdit(r)}
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-md
                    text-gray-500
                    hover:bg-surface-100
                    hover:text-primary-600
                    transition-colors
                  "
                  title="Update"
                >
                  <Pencil size={16} />
                </button>

                <button
                  type="button"
                  onClick={() => handleDelete(r)}
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-md
                    text-gray-500
                    hover:bg-red-50
                    hover:text-red-600
                    transition-colors
                  "
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ),
          },
        ]}
      />

      <AssignEmployeeSalaryDialog
        open={open}
        onClose={handleClose}
        onExited={handleDialogExited}
        onSave={handleSave}
        employees={employees}
        payrollPeriods={periods}
        employeeSalaries={list}
        mode={dialogMode}
        salary={selectedSalary}
      />
    </>
  );
};
*/

/* ── Salary Components ───────────────────────────────────────────────────── */
/*
const SalaryComponentsTab = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  const { list, loading } = usePayrollEntity('employeeSalaryComponents');
  const { list: components } = usePayrollEntity('payrollComponents');
  const { list: employeeSalaries } = usePayrollEntity('employeeSalary');

  const [open, setOpen] = useState(false);
  const [employeeSalaryId, setEmployeeSalaryId] = useState('');

  const filtered = list
    .filter((x) => String(x.employeeSalaryId) === String(employeeSalaryId))
    .map((x) => ({
      ...x,
      componentName: components.find((c) => c.id === x.componentId)?.name ?? x.remarks,
    }));

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('employeeSalaryComponents', form));
    setOpen(false);
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        search={false}
        title="Salary Components"
        loading={loading}
        rows={filtered}
        rowKey="id"
        emptyMessage="Please select an employee to view records."
        onAdd={{
          label: 'Assign Component',
          icon: <Plus {...ICON} />,
          onClick: () => {
            if (!employeeSalaryId) return;
            setOpen(true);
          },
        }}
        toolbarExtra={
          <div className="w-[320px] max-w-full">
            <span className={LABEL}>Employee</span>
            <select
              value={employeeSalaryId}
              onChange={(e) => setEmployeeSalaryId(e.target.value)}
              className={`${FIELD} w-full`}
            >
              <option value="">Select Employee</option>
              {employeeSalaries.map((salary) => (
                <option key={salary.id} value={salary.id}>
                  {salary.empNo} - {salary.name}
                </option>
              ))}
            </select>
          </div>
        }
        columns={[
          { key: 'componentName', label: 'Component', grow: true, className: 'font-semibold text-gray-900' },
          { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.amount) },
          { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          { key: 'endDate', label: 'End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
          {
            key: 'status',
            label: 'Status',
            align: 'center',
            render: (r) => <StatusPill label={r.isActive ? 'Active' : 'Inactive'} />,
          },
        ]}
      />

      <AddEmployeeSalaryComponentDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        employeeSalaryId={employeeSalaryId}
        payrollComponents={components}
      />
    </>
  );
};
/*

/* ── Salary Revision ─────────────────────────────────────────────────────── */
/*
const SalaryRevisionTab = () => {
  const { list, loading } = usePayrollEntity('salaryRevision');
  return (
    <Table
      {...TABLE_PROPS}
      title="Salary Revision"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['empNo', 'name']}
      searchPlaceholder="Search salary revisions..."
      emptyMessage="No salary revisions found"
      onAdd={{ label: 'New Revision', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
        { key: 'oldBasic', label: 'Old Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
        { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
        { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
        { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
        { key: 'reason', label: 'Reason', className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};
/*

/* ── Increment History ───────────────────────────────────────────────────── */
/*
const IncrementHistoryTab = () => {
  const { list, loading } = usePayrollEntity('incrementHistory');
  return (
    <Table
      {...TABLE_PROPS}
      title="Increment History"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['empNo', 'name', 'cycle']}
      searchPlaceholder="Search increment history..."
      emptyMessage="No increment history found"
      columns={[
        { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
        { key: 'cycle', label: 'Review Cycle', className: 'text-gray-600' },
        { key: 'oldBasic', label: 'Previous Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
        { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
        { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
        { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
      ]}
    />
  );
};
/*

/* ── Page ────────────────────────────────────────────────────────────────── */
/*
const PayrollEmployeeSalary = () => {
  const tabs = [
    { key: 'salary', label: 'Employee Salary', icon: <Users {...ICON} />, content: <EmployeeSalaryTab /> },
    { key: 'components', label: 'Salary Components', icon: <ListOrdered {...ICON} />, content: <SalaryComponentsTab /> },
    // { key: 'revision', label: 'Salary Revision', icon: <TrendingUp {...ICON} />, content: <SalaryRevisionTab /> },
    // { key: 'history', label: 'Increment History', icon: <History {...ICON} />, content: <IncrementHistoryTab /> },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Employee Salary']}
        title="Employee Salary"
        subtitle="Assign, revise and track individual employee salary records."
      />
      <Tabs tabs={tabs} defaultTab="salary" />
    </div>
  );
};

export default PayrollEmployeeSalary;
*/

// -------------------------------------------------------------------------------------------------------

// const PayrollEmployeeSalary = () => {
//   const dispatch = useDispatch();
//   const confirm = useConfirm();

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState("add");
//   const [selectedSalary, setSelectedSalary] = useState(null);

//   const employees = useSelector((state) => state.employees.employees);
//   const designations = useSelector((state) => state.designationSlice.designations);

//   const employeeMap = employees.reduce((map, emp) => {
//     map[emp.HED_SERVICE_NO] = emp;
//     return map;
//   }, {});

//   const designationMap = designations.reduce((map, designation) => {
//     map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
//     return map;
//   }, {});

//   const { list, loading } = usePayrollEntity("employeeSalary");
//   const { list: components } = usePayrollEntity("employeeSalaryComponents");
//   const { list: payrollComponents } = usePayrollEntity("payrollComponents");

//   const { toast, showToast, hideToast } = useToast();

//   useEffect(() => {
//     dispatch(fetchAllEmployees());
//     dispatch(getDesignationList());
//   }, [dispatch]);

//   const handleAdd = () => {
//     setSelectedSalary(null);
//     setDialogMode("add");
//     setOpen(true);
//   };

//   const handleView = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("view");
//     setOpen(true);
//   };

//   const handleEdit = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("edit");
//     setOpen(true);
//   };

//   const handleSave = async (form, pendingComponents = []) => {
//     try {
//       const isEdit = dialogMode === "edit";

//       // Save employee salary and get the employeeSalaryId
//       const employeeSalaryId = await dispatch(
//         savePayrollEntity(
//           "employeeSalary",
//           form,
//           isEdit
//         )
//       );

//       // For the new salary, save each salary component
//       if (pendingComponents.length > 0) {
//         await Promise.all(
//           pendingComponents.map((component) => {
//             dispatch(
//               savePayrollEntity(
//                 "employeeSalaryComponents",
//                 {
//                   employeeSalaryId,
//                   componentId: component.componentId,
//                   amount: component.amount,
//                   percentage: component.percentage,
//                   effectiveDate: component.effectiveDate,
//                   endDate: component.endDate,
//                   isActive: component.isActive,
//                   remarks: component.remarks,
//                 },
//                 false
//               )
//             )
//           })
//         )
//       }

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode("add");

//       showToast(isEdit ? "Employee salary updated successfully." : "Employee salary saved successfully.", "success");

//     } catch (error) {
//       console.error("Failed to save employee salary: ", error);

//       showToast(
//         error?.response?.data?.message ||
//         error?.response?.data?.Message ||
//         error?.message ||
//         "Failed to save employee salary.",
//         'error'
//       );
//     }
//   };

//   const handleUpdateComponent = async (component) => {
//     try {
//       await dispatch(
//         savePayrollEntity(
//           "employeeSalaryComponents",
//           component,
//           true
//         )
//       );

//       showToast("Salary component updated successfully.", "success");
//     } catch (error) {
//       console.error("Failed to update salary component: ", error);
//       showToast(
//         error?.response?.data?.Message ||
//         error?.response?.data?.message || 
//         error?.message || 
//         "Failed to update salary component.",
//         "error"
//       )

//       throw error;
//     }
//   }

//   const handleDelete = async (record) => {
//     const confirmed = await confirm({
//       title: "Delete this salary?",
//       message: `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`,
//       confirmLabel: "Delete",
//       cancelLabel: "Cancel",
//     })

//     if (!confirmed) {
//       return;
//     }

//     try {
//       await dispatch(
//         savePayrollEntity(
//           'employeeSalary',
//           {
//             id: record.id,
//             isActive: false,
//           },
//           true
//         )
//       );

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode('add');
//     } catch (err) {
//       console.error('Failed to delte employee salary: ', err);
//     }
//   }

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={["Payroll", "Employee Salary"]}
//         title="Employee Salary"
//         subtitle="Assign, revise and track individual employee salary records."
//       />

//       <Table
//         {...TABLE_PROPS}
//         title="Employee Salary"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={["empNo", "name", "department"]}
//         searchPlaceholder="Search by employee name or number..."
//         emptyMessage="No salary records found"
//         onAdd={{
//           label: "Assign Salary",
//           icon: <Plus {...ICON} />,
//           onClick: handleAdd,
//         }}
//         columns={[
//           { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
//           {
//             key: 'designation',
//             label: 'Designation',
//             className: 'text-gray-600',
//             render: (r) => {
//               const emp = employeeMap[r.empNo];
//               return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
//             },
//           },
//           { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
//           { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
//           // { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
//           // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
//           { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
//           { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-2">
//                 <button
//                   type="button"
//                   onClick={() => handleView(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="View"
//                 >
//                   <Eye size={16} /> 
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEdit(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="Update"
//                 >
//                   <Pencil size={16} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDelete(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-red-50
//                     hover:text-red-600
//                     transition-colors
//                   "
//                   title="Delete"
//                 >
//                   <Trash2 size={16} />
//                 </button> 
//               </div>
//             ),
//           },
//         ]}
//       />

//       <EmployeeSalaryDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         onSaveComponent={handleUpdateComponent}
//         employees={employees}
//         employeeSalaries={list}
//         salary={selectedSalary}
//         mode={dialogMode}
//         salaryComponents={components}
//         payrollComponents={payrollComponents}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollEmployeeSalary;

// -----------------------------------------------------------------------------------------

import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Tabs from '../../../components/Tabs/Tabs';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
import { Plus, Eye, Pencil, Trash2, CalendarDays, Wallet } from "lucide-react";

import usePayrollEntity from "../../../utils/usePayrollEntity";
import { useConfirm } from "../../../utils/ConfirmContext";
import useToast from "../../../utils/useToast";
import Toast from "../../../components/Toast/Toast";
import { fmtMoney } from "../../../utils/payrollFormat";
import toIsoDate from "../../../utils/dateFormat";

import { fetchAllEmployees } from "../../../store/slices/employeeSlice";
import { getDesignationList } from "../../../store/slices/designationSlice";
import { savePayrollEntity } from "../../../store/slices/payrollSlice";

import EmployeeSalaryDialog from "../../../components/EmployeeSalary/EmployeeSalaryDialog";
import AddMonthlyDeductionDialog from "../../../components/PayRoll/AddMonthlyDeductionDialog";

const TABLE_PROPS = { 
  search: true,
  searchLabel: "Search",
  pageSize: 10,
  emptyMessage: "No records found",
  loadingMessage: "Loading...",
};

const statusColumn = {
  key: "status",
  label: "Status",
  align: "center",
  render: (r) => <StatusPill label={r.status || (r.isActive ? "Active" : "Inactive")} />,
};

/* ── Salary Overview Tab (Your original functionality) ────────────────────── */
const SalaryOverviewTab = ({ 
  list, loading, employeeMap, designationMap, employees, components, payrollComponents,
  open, setOpen, dialogMode, setDialogMode, selectedSalary, setSelectedSalary, handleSave, handleUpdateComponent, handleDelete 
}) => {
  const handleAdd = () => { setSelectedSalary(null); setDialogMode("add"); setOpen(true); };
  const handleView = (r) => { setSelectedSalary(r); setDialogMode("view"); setOpen(true); };
  const handleEdit = (r) => { setSelectedSalary(r); setDialogMode("edit"); setOpen(true); };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Employee Salary"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={["empNo", "name"]}
        searchPlaceholder="Search by employee name or number..."
        onAdd={{ label: "Assign Salary", icon: <Plus size={15} />, onClick: handleAdd }}
        columns={[
          { key: "empNo", label: "Staff Id", className: "font-semibold text-gray-900" },
          { key: "name", label: "Employee", grow: true, className: "text-gray-700" },
          {
            key: "designation", label: "Designation", className: "text-gray-600",
            render: (r) => {
              const emp = employeeMap[r.empNo];
              return emp ? designationMap[emp.HED_DESIGNATION_ID] || "-" : "-";
            },
          },
          { key: "payFrequency", label: "Frequency", className: "text-gray-600" },
          { key: "basic", label: "Basic Salary (Rs)", align: "right", className: "font-semibold text-gray-900", render: (r) => fmtMoney(r.basic) },
          { key: "dailyRate", label: "Daily Rate (Rs)", align: "right", className: "text-gray-600", render: (r) => fmtMoney(r.dailyRate) },
          { key: "effectiveStartDate", label: "Start Date", align: "center", className: "text-gray-600 tabular-nums", render: (r) => toIsoDate(r.effectiveDate) },
          { key: "effectiveEndDate", label: "End Date", align: "center", className: "text-gray-600 tabular-nums", render: (r) => toIsoDate(r.endDate) },
          statusColumn,
          {
            key: "actions", label: "Actions", align: "center",
            render: (r) => (
              <div className="flex items-center justify-center gap-2">
                <button onClick={() => handleView(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600"><Eye size={16} /></button>
                <button onClick={() => handleEdit(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600"><Pencil size={16} /></button>
                <button onClick={() => handleDelete(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-red-50 hover:text-red-600"><Trash2 size={16} /></button>
              </div>
            ),
          },
        ]}
      />
      <EmployeeSalaryDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        onSaveComponent={handleUpdateComponent}
        employees={employees}
        employeeSalaries={list}
        salary={selectedSalary}
        mode={dialogMode}
        salaryComponents={components}
        payrollComponents={payrollComponents}
      />
    </>
  );
};

/* ── Monthly Deductions Tab ──────────────────────────────────────────────── */
const MonthlyDeductionsTab = ({ components, payrollComponents, employees, employeeSalaries }) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { toast, showToast } = useToast();

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("add"); // "add" | "edit" | "view"
  const [selectedDeduction, setSelectedDeduction] = useState(null);
  const [employeeFilter, setEmployeeFilter] = useState("All");

  // Filter out only the components that belong to a deduction, and apply the employee filter
  const deductionsList = useMemo(() => {
    const deductionCompIds = payrollComponents
      .filter((c) => c.type === "Deduction")
      .map((c) => String(c.id));
    
    let list = components
      .filter((c) => deductionCompIds.includes(String(c.componentId)))
      .map((comp) => {
        const pc = payrollComponents.find((p) => String(p.id) === String(comp.componentId));
        return {
          ...comp,
          componentName: pc?.name || "Unknown",
        };
      });

    // Apply the employee dropdown filter
    if (employeeFilter !== "All") {
      list = list.filter((c) => String(c.employeeId) === String(employeeFilter));
    }

    return list;
  }, [components, payrollComponents, employeeFilter]);

  const handleAdd = () => {
    setSelectedDeduction(null);
    setDialogMode("add");
    setOpen(true);
  };

  const handleView = (record) => {
    setSelectedDeduction(record);
    setDialogMode("view");
    setOpen(true);
  };

  const handleEdit = (record) => {
    setSelectedDeduction(record);
    setDialogMode("edit");
    setOpen(true);
  };

  const handleDeleteDeduction = async (record) => {
    const confirmed = await confirm({
      title: "Deactivate Deduction?",
      message: `Are you sure you want to deactivate the ${record.componentName} deduction for ${record.name || record.empNo}?`,
      confirmLabel: "Deactivate",
      cancelLabel: "Cancel",
    });

    if (confirmed) {
      try {
        await dispatch(
          savePayrollEntity(
            "employeeSalaryComponents",
            {
              employeeSalaryComponentId: record.id,
              employeeSalaryId: record.employeeSalaryId,
              componentId: record.componentId,
              componentAmount: record.amount,
              componentPercentage: record.percentage || 0,
              effectiveDate: record.effectiveDate,
              endDate: record.endDate,
              isActive: false, // Soft delete
              remarks: record.remarks ?? "",
            },
            true
          )
        );
        showToast("Deduction record deactivated successfully.", "success");
      } catch (error) {
        showToast(error?.message || "Failed to deactivate deduction.", "error");
      }
    }
  };

  const handleSaveDeduction = async (payload, isEdit = false) => {
    try {
      await dispatch(savePayrollEntity("employeeSalaryComponents", payload, isEdit));
      showToast(
        isEdit ? "Deduction record updated successfully." : "Deduction record added successfully.",
        "success"
      );
    } catch (error) {
      showToast("Failed to save deduction.", "error");
      throw error;
    }
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Monthly Deductions"
        rows={deductionsList}
        rowKey="id"
        searchKeys={["empNo", "name", "componentName"]}
        searchPlaceholder="Search deductions..."
        onAdd={{ label: "Add Deduction", icon: <Plus size={15} />, onClick: handleAdd }}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-2">
            <div>
              <span className="text-[11px] font-medium text-gray-500 mb-1 block">Filter by Employee</span>
              <select
                value={employeeFilter}
                onChange={(e) => setEmployeeFilter(e.target.value)}
                className="h-9 bg-white border border-gray-200 rounded-lg text-xs px-2.5 outline-none text-gray-700 w-[200px]"
              >
                <option value="All">All Employees</option>
                {employees.map((emp) => (
                  <option key={emp.HED_EMPLOYEE_ID} value={emp.HED_EMPLOYEE_ID}>
                    {emp.HED_SERVICE_NO} - {emp.HED_REPORT_NAME}
                  </option>
                ))}
              </select>
            </div>
          </div>
        }
        columns={[
          { key: "empNo", label: "Staff Id", className: "font-semibold text-gray-900" },
          { key: "name", label: "Employee", grow: true, className: "text-gray-700" },
          { key: "componentName", label: "Deduction", className: "text-gray-700" },
          { key: "amount", label: "Amount (Rs)", align: "right", className: "font-semibold text-gray-900", render: (r) => fmtMoney(r.amount) },
          { key: "effectiveDate", label: "Start Date", align: "center", className: "text-gray-600 tabular-nums", render: (r) => toIsoDate(r.effectiveDate) },
          { key: "endDate", label: "End Date", align: "center", className: "text-gray-600 tabular-nums", render: (r) => toIsoDate(r.endDate) },
          statusColumn,
          {
            key: "actions",
            label: "Actions",
            align: "center",
            render: (r) => (
              <div className="flex items-center justify-center gap-2">
                <button
                  type="button"
                  onClick={() => handleView(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600"
                  title="View Deduction"
                >
                  <Eye size={16} />
                </button>
                <button
                  type="button"
                  onClick={() => handleEdit(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600"
                  title="Edit Deduction"
                >
                  <Pencil size={16} />
                </button>
                <button
                  type="button"
                  onClick={() => handleDeleteDeduction(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-red-50 hover:text-red-600"
                  title="Deactivate Deduction"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ),
          },
        ]}
      />
      
      <AddMonthlyDeductionDialog
        open={open}
        mode={dialogMode}
        initialData={selectedDeduction}
        onClose={() => setOpen(false)}
        onSave={handleSaveDeduction}
        employees={employees}
        employeeSalaries={employeeSalaries}
        payrollComponents={payrollComponents}
      />
    </>
  );
};

/* ── Main Page Component ─────────────────────────────────────────────────── */
const PayrollEmployeeSalary = () => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { toast, showToast, hideToast } = useToast();

  const [salaryDialogOpen, setSalaryDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");
  const [selectedSalary, setSelectedSalary] = useState(null);

  const employees = useSelector((state) => state.employees.employees);
  const designations = useSelector((state) => state.designationSlice.designations);

  const employeeMap = useMemo(() => employees.reduce((m, e) => { m[e.HED_SERVICE_NO] = e; return m; }, {}), [employees]);
  const designationMap = useMemo(() => designations.reduce((m, d) => { m[d.HED_DESIGNATION_ID] = d.HED_DESIGNATION_NAME; return m; }, {}), [designations]);

  const { list: employeeSalaries, loading } = usePayrollEntity("employeeSalary");
  const { list: components } = usePayrollEntity("employeeSalaryComponents");
  const { list: payrollComponents } = usePayrollEntity("payrollComponents");

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(getDesignationList());
  }, [dispatch]);

  const handleSaveSalary = async (form, pendingComponents = []) => {
    try {
      const isEdit = dialogMode === "edit";
      const employeeSalaryId = await dispatch(savePayrollEntity("employeeSalary", form, isEdit));

      if (pendingComponents.length > 0) {
        await Promise.all(
          pendingComponents.map((component) =>
            dispatch(
              savePayrollEntity(
                "employeeSalaryComponents",
                { ...component, employeeSalaryId },
                false
              )
            )
          )
        );
      }

      setSalaryDialogOpen(false);
      showToast(isEdit ? "Employee salary updated successfully." : "Employee salary saved successfully.", "success");
    } catch (error) {
      showToast(error?.message || "Failed to save employee salary.", "error");
    }
  };

  const handleUpdateComponent = async (component) => {
    try {
      await dispatch(savePayrollEntity("employeeSalaryComponents", component, true));
      showToast("Salary component updated successfully.", "success");
    } catch (error) {
      showToast(error?.message || "Failed to update salary component.", "error");
      throw error;
    }
  };

  const handleDeleteSalary = async (record) => {
    const confirmed = await confirm({
      title: "Delete this salary?",
      message: `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`,
      confirmLabel: "Delete",
      cancelLabel: "Cancel",
    });

    if (confirmed) {
      try {
        await dispatch(savePayrollEntity("employeeSalary", { id: record.id, isActive: false }, true));
      } catch (err) {
        console.error("Failed to delete employee salary: ", err);
      }
    }
  };

  const tabs = [
    {
      key: "overview",
      label: "Salary Base & Structure",
      icon: <Wallet size={15} />,
      content: (
        <SalaryOverviewTab
          list={employeeSalaries} loading={loading} employeeMap={employeeMap} designationMap={designationMap}
          employees={employees} components={components} payrollComponents={payrollComponents}
          open={salaryDialogOpen} setOpen={setSalaryDialogOpen} dialogMode={dialogMode} setDialogMode={setDialogMode}
          selectedSalary={selectedSalary} setSelectedSalary={setSelectedSalary}
          handleSave={handleSaveSalary} handleUpdateComponent={handleUpdateComponent} handleDelete={handleDeleteSalary}
        />
      ),
    },
    // {
    //   key: "deductions",
    //   label: "Monthly Deductions",
    //   icon: <CalendarDays size={15} />,
    //   content: (
    //     <MonthlyDeductionsTab
    //       components={components}
    //       payrollComponents={payrollComponents}
    //       employees={employees}
    //       employeeSalaries={employeeSalaries}
    //     />
    //   ),
    // },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={["Payroll", "Employee Salary"]}
        title="Employee Salary"
        subtitle="Assign, revise base salaries and manage bulk recurring deductions."
      />
      <Tabs tabs={tabs} defaultTab="overview" />
      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </div>
  );
};

export default PayrollEmployeeSalary;